import React from 'react';

function NumpadRowItem({ buttonValue, handleClick, index, betAmount }) {
  return (
    <button
      key={`${buttonValue}-${index}`}
      className={`numpad-btn-item top-item ${betAmount === buttonValue ? 'selected' : ''}`}
      onClick={handleClick}
    >
      {buttonValue}
    </button>
  );
}

export default NumpadRowItem;
